// extracted by mini-css-extract-plugin
module.exports = {"confirmationWrapper":"ed","header":"ee","title":"ef","subHeader":"eh","buttonsWrapper":"ei","confirmButton":"ej","large":"ek","cancelButton":"el"};